webpackJsonp([915738553496],{

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _privacyModule = __webpack_require__(418);
	
	var _privacyModule2 = _interopRequireDefault(_privacyModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import Layout from '../layouts/index'
	var Privacy = function Privacy() {
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%' } },
	    _react2.default.createElement(
	      'div',
	      { className: _privacyModule2.default.container },
	      _react2.default.createElement('div', { className: _privacyModule2.default.topBack }),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_privacyModule2.default.contentContainer) },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Privacy Policy'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Trillium Gardens is committed to your privacy. This page informs you of our policies regarding the collection, use and disclosure of personal data when you access our website, and what choices you have associated with that data.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We use your data to provide and improve the content and design of our website. By accessing the website, you agree to the collection and use of information in accordance with this policy. '
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Information Collection and Use'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Trillium Gardens does not collect personal information (e.g., name, address or telephone number) unless you provide it to us by contacting us separately via email or phone.  We do not share any personal information with any third parties.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We may collect information that your browser sends whenever you visit our website.  This usage data may include information such as your computer\'s Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our website that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'When you access the website by or through a mobile device, this usage data may include information such as the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile internet browser you use, unique device identifiers and other diagnostic data.'
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Cookies'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'To track the activity on our website, we may use cookies and similar tracking technologies.  Cookies are files with a small amount of data that may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device.  You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. '
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Google Analytics'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We may use Google Analytics on our website.  Google Analytics is a web analytics service offered by Google that tracks and reports website traffic. Google uses the data collected to track and monitor the use of our website. This data is shared with other Google services. Google may use the collected data to contextualize and personalize the ads of its own advertising network.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'You can opt-out of having made your activity on this website available to Google Analytics by installing the Google Analytics opt-out browser add-on (',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://tools.google.com/dlpage/gaoptout' },
	              'https://tools.google.com/dlpage/gaoptout'
	            ),
	            '). The add-on prevents the Google Analytics JavaScript (ga.js, analytics.js, and dc.js) from sharing information with Google Analytics about visits activity.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'For more information on the privacy practices of Google, please visit the Google Privacy & Terms web page: (',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://policies.google.com/privacy?hl=en' },
	              'https://policies.google.com/privacy?hl=en'
	            ),
	            ')'
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Links to External Sites'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Our website may contain links to other sites that are not operated by us.  Please be aware that we have no control over the content and practices of these sites; we advise you to review the privacy policy of any site you visit.'
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Questions'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If you have any questions about this privacy policy, please contact us at: ',
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:admin@trilliumgardens.com' },
	              'admin@trilliumgardens.com'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Privacy;
	module.exports = exports['default'];

/***/ }),

/***/ 418:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-pages----privacy-module---container---10UiJ","contentContainer":"src-pages----privacy-module---contentContainer---LaTbV","topBack":"src-pages----privacy-module---topBack---1F4k4"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-js-b342ae6a2ff9124bf317.js